import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class BigdesCurrentSituationEvaluationScopeApi extends BaseApi {
    constructor(client) {
        super(client, '/bigdes-current-situation-evaluation-scope');
    }

    async getScope() {
        try {
            const response = await this.client.get(this.basePath);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async updateScope(data) {
        try {
            const response = await this.client.put(this.basePath, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
